import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent extends FieldWrapper {

  getLabel() {
    if (this.props['attributeTypeLabels'][this.props['index']].name.length > 0) {
      return `${this.props.label} - ${this.props['attributeTypeLabels'][this.props['index']].name}`;
    } else {
      return this.props.label;
    }
  }
}
